import { CommonEditContext, CreateCommonSearchContext } from "./common-data.model";

export const DefaultOrgUnit = {
    search: CreateCommonSearchContext(),
    edit: {
        editForm: {
            model: {} as OrgUnitEditCriteria,
            dirty: false,
            status: null as any,
            errors: null as any
        },
    } as CommonEditContext<OrgUnitEditCriteria>,
}

export interface OrgUnitEditCriteria {        
    newOrgUnitMap: boolean;
    terminalId:string;    
    terminal_id: number;
    subregion_id: number;
    terminalName:string;
    country:string;
}
